import { render, staticRenderFns } from "./overpHistory.vue?vue&type=template&id=f54eb548&scoped=true&"
import script from "./overpHistory.vue?vue&type=script&lang=js&"
export * from "./overpHistory.vue?vue&type=script&lang=js&"
import style0 from "./overpHistory.vue?vue&type=style&index=0&id=f54eb548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54eb548",
  null
  
)

export default component.exports